(function () {
    'use strict';

    var Presenter = function (view) {
        this.view = view;
        this.view.formError = false;
        this.view.formEnabled = false;
        this.view.success = false;
    };

    Presenter.prototype.showForm = function () {
        this.view.formError = false;
        this.view.formEnabled = true;
        this.view.success = false;
    };

    Presenter.prototype.showError = function () {
        this.view.formError = true;
        this.view.formEnabled = true;
        this.view.success = false;
    };

    Presenter.prototype.reset = function () {
        this.view.formError = false;
        this.view.formEnabled = false;
        this.view.success = false;
    };

    Presenter.prototype.showSuccess = function () {
        this.view.formError = false;
        this.view.formEnabled = false;
        this.view.success = true;
    };

    angular.module('ShargoApp')
        .controller('RecoverController', function ($rootScope, $scope, $routeParams, $location, $http, Configuration) {
            $scope.view = {};
            var presenter = new Presenter($scope.view);

            if ($routeParams.token === undefined) {
                $location.path( $rootScope.url('notfound') );
            }
            $http.get(Configuration.apiUrl + "/password/reset?token=" + $routeParams.token).then(function () {
                presenter.showForm();
            }, function () {
                $location.$$search = {};
                $location.path( $rootScope.url('notfound') );
            });

            $scope.recoverPassword = function () {
                presenter.reset();
                $scope.recoverPass1Error = false;
                $scope.recoverPass2Error = false;

                if ($scope.password === undefined || $scope.password.length == 0) {
                    presenter.showError();
                    $scope.recoverPass1ErrorMsg = "recover.error-valid-password";
                    $scope.recoverPass1Error = true;
                }
                if ($scope.password2 === undefined || $scope.password2.length == 0) {
                    presenter.showError();
                    $scope.recoverPass2ErrorMsg = "recover.error-valid-password";
                    $scope.recoverPass2Error = true;
                }
                if ($scope.password.length > 0 && $scope.password2.length > 0) {
                    presenter.showError();
                    if ($scope.password !== $scope.password2) {
                        $scope.recoverPass1ErrorMsg = "recover.error-same-password";
                        $scope.recoverPass1Error = true;
                    } else {
                        $http.post(Configuration.apiUrl + '/password/reset', {
                            token: $routeParams.token,
                            newPassword: $scope.password
                        }).then(function () {
                            presenter.showSuccess();
                        }, function (response) {
                            presenter.showError();
                            $scope.recoverPass1Error = true;
                            $scope.recoverPass1ErrorMsg = response.data.message;
                        });
                    }
                }
            };
        });
})();